import axios from "axios";
import { API_BASE_URL } from "../config/api";
const API_USERNAME = process.env.REACT_APP_API_USERNAME;
const API_PASSWORD = process.env.REACT_APP_API_PASSWORD;

// import dotenv from "dotenv";
let token = null;
// dotenv.config();
// Function to get the token
const getToken = async () => {
  try {
    const response = await axios.post(`${API_BASE_URL}/Authorization/login`, {
      // Include your login credentials here
      username: API_USERNAME,
      password: API_PASSWORD,
    });

    token = response.data.token;
  } catch (error) {
    console.error("Error fetching token:", error);
    throw error;
  }
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
api.interceptors.request.use(
  async (config) => {
    await getToken();
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
